import { captureException } from '@sentry/browser'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'

export const initFirebase = (): void => {
  const firebaseConfig = {
    apiKey: window._env_.REACT_APP_FIREBASE_API_KEY,
    authDomain: window._env_.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: window._env_.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: window._env_.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: window._env_.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: window._env_.REACT_APP_FIREBASE_APP_ID,
    measurementId: window._env_.REACT_APP_FIREBASE_MEASUREMENT_ID,
  }

  initializeApp(firebaseConfig)
}

export const getRegisterToken = async (): Promise<string> => {
  const messaging = getMessaging()

  try {
    const token = await getToken(messaging, {
      vapidKey: window._env_.REACT_APP_FIREBASE_VAPID_KEY,
    })

    return token
  } catch (error) {
    captureException(error)

    return ''
  }
}
